import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  useFetchAuthorisation,
  authorisationConverter,
  useFetchUserData,
} from "../../utils/AppFunctions";
import config from "../../app-config";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import { create_new_contact_group, delete_contact_group, fetch_contact_group_by_id, update_contact_group_by_id } from "../../api/campaignsAPI";
import notify from "../../utils/IANotification";
import { captialise_first_letter, tidy_date } from "../../utils/helper";
import { MdAdd, MdCheck } from "react-icons/md";
import DataTable from "../../components/ui/DataTable";
import Switch from 'react-switch'
import Select from 'react-select'
import { fetch_all_users_admin } from "../../api/usersAPI";

export default function CampaignGroupFormPage() {
  const navigate = useNavigate();
  let user_data = useFetchUserData();
  let group_id = new URLSearchParams(window.location.search).get("group_id");
  const [groupData, setGroupData] = useState({
    name: "",
    description: "",
    user_ids: [],
    email_list: [],
  })
  const [loading, setLoading] = useState(true)
  const [users, setUsers] = useState([])

  useEffect(() => {
    fetchCampaignGroupById()
    fetchPlatformUsers()
  }, [])


  const fetchPlatformUsers = async () => {
    setLoading(true)
    const data = await fetch_all_users_admin()
    if (data?.status === 200) {
      setUsers(data.data)
      console.log(data.data)
    }
    setLoading(false)
  }


  const fetchCampaignGroupById = async () => {
    if (!group_id || group_id === "new") return
    setLoading(true)
    const { data, error, message, status } = await fetch_contact_group_by_id(group_id)
    if (error) notify({ message: message || error, type: 'error' })
    setGroupData(data)
    setLoading(false)
  }

  const createNewCampaignGroup = async () => {
    const { data, error, message, status } = await create_new_contact_group(groupData)
    if (error) notify({ message: message || error, type: 'error' })
    notify({ message: "Campaign group created successfully", type: 'success' })
    navigate(`/admin/campaigns/groups-tags/details?group_id=${data.id}`)
  }

  const updateContactGroupById = async () => {
    if (!group_id) return
    const { data, error, message, status } = await update_contact_group_by_id(group_id, groupData)
    if (error) notify({ message: message || error, type: 'error' })
    notify({ message: "Campaign group updated successfully", type: 'success' })
    fetchCampaignGroupById()
  }

  const deleteContactGroupById = async () => {
    if (!group_id) return
    const { data, error, message, status } = await delete_contact_group(group_id)
    if (error) notify({ message: message || error, type: 'error' })
    notify({ message: "Campaign group deleted successfully", type: 'success' })
    navigate(-1)
  }

  const selectOptions = [
    { value: 'draft', label: 'Draft' },
    { value: 'scheduled', label: 'Schedule' },
  ]

  

  return (
    <AdminLayout navSelected={"Groups & Tags"}
      toolbar={
        <>
          <h1 className="text-2xl font-bold text-gray-900">
            {group_id === "new" ? "Create Group" : "Edit Group"}
          </h1>
          <div className="flex gap-2">
            {group_id !== "new" && (
              <button 
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                onClick={deleteContactGroupById}
              >
                Delete
              </button>
            )}
            <button 
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              onClick={() => {
                if (group_id === "new") {
                  createNewCampaignGroup()
                } else {
                  updateContactGroupById()
                }
              }}
            >
              {group_id === "new" ? "Create" : "Save"}
            </button>
          </div>
        </>
      }
    >
      <div className="w-full">
        <div className="card mb-2">
          <p className="card-title">Group Details</p>
          <div className="input-container">
            <label htmlFor="name" className="input-label">Name</label>
            <input type="text" id="name" className="text-input"
              value={groupData.name}
              onChange={(e) => setGroupData({ ...groupData, name: e.target.value })}
              placeholder="e.g. Library Ministry"
            />
          </div>
          <div className="input-container">
            <label htmlFor="description" className="input-label">Description</label>
            <textarea id="description" className="textarea-input"
              value={groupData.description}
              onChange={(e) => setGroupData({ ...groupData, description: e.target.value })}
              placeholder="e.g. This is a description for the group"
            />
          </div>
        </div>
      </div>
      <div className="w-full">
        <div className="card mb-2">
          <p className="card-title">Contact Details</p>
          <div className="flex flex-row items-start gap-2">
            <div className="input-container">
              <label htmlFor="email_list" className="input-label">Email List</label>
              <textarea id="email_list" className="textarea-input"
                value={groupData.email_list}
                onChange={(e) => setGroupData({ ...groupData, email_list: e.target.value })}
                placeholder="e.g. email1@example.com"
              />
            </div>
            <div className="input-container">
              <label htmlFor="description" className="input-label">Users</label>
              <div className="flex flex-row items-center gap-2">
                <Select
                  value={users.filter(user => groupData.user_ids.includes(user.id)).map(user => ({ value: user.id, label: `${user.first_name} ${user.last_name} (${user.email})` }))}
                  options={users.map(user => ({ value: user.id, label: `${user.first_name} ${user.last_name} (${user.email})` }))}
                  isMulti
                  styles={{ container: (base) => ({ ...base, width: "100%" }) }}
                  onChange={(selected) => setGroupData({ ...groupData, user_ids: selected.map(s => s.value) })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <pre>{JSON.stringify(groupData, null, 2)}</pre> */}
    </AdminLayout>
  )
}